<template>
    <div class="h-100">

        <h1 v-text="contents.insert_pin_1" class="desktop-title" v-if="$web.isDesktop"/>

        <TopBg :showBg="!$web.isDesktop"
               :class="{'desktop-card desktop-card-small':$web.isDesktop}">

            <!-- Top logo -->
            <TopLogo :white="true" v-if="!$web.isDesktop"/>

            <!-- Pin label -->
            <div v-text="contents.insert_pin_1" class="pin-title" v-if="!$web.isDesktop"/>
            <label for="pin" v-text="textLine2" class="pin-label"/>

            <!-- Pin input -->
            <TextInput
                    id="pin"
                    :value="pin"
                    @input="pin = $event.value"
                    type="number"
                    :focus="true"/>

            <!-- Continue button -->
            <Btn
                    :text="contents.proceed"
                    @click="verifyPin"
                    :disabled="!pin"/>

        </TopBg>
    </div>
</template>

<script>
    import contents from "../contents/login"
    import TopBg from "../components/TopBg"
    import TopLogo from "../components/TopLogo"
    import TextInput from "../components/TextInput";
    import Btn from "../components/Btn";

    export default {
        name: 'verify-pin',
        components: {
            Btn,
            TextInput,
            TopBg,
            TopLogo
        },
        mounted(){
            this.$registerEvent('Pagina', '7. Verifica PIN');
        },
        data() {
            return {
                contents,
                pin: null
            };
        },
        methods: {
            async verifyPin() {
                try {
                    await this.$api.verifyPin(
                        this.$store.state.subscriber_email, this.pin
                    );
                } catch (e) {
                    if (e.response && e.response.status === 422) {
                        this.$alert(this.contents.pin_error);

                        return this.$router.push('/login');
                    }
                    throw e;
                }
                this.$registerEvent('Azione', 'Utente registrato tramite Email');
                this.$registerFacebookEvent('CompleteRegistration');
                this.$redirectAfterLogin();
            },
            redirectIfLoggedIn(){
                if (this.$auth.isLoggedIn()) {
                    this.$router.push('/')
                }
            }
        },
        computed: {
            textLine2(){
              return this.contents.insert_pin_2.replace(
                  /{email}/,
                  this.$store.state.subscriber_email
              )
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "../styles/colors.scss";

    .pin-title {
        margin-top: 160px;
        margin-bottom: 15px;
    }

    .desktop-card {
        .pin-title {
            margin-top: 0;
            margin-bottom: 15px;
        }
    }

    .pin-title, .pin-label {
        font-family: "Poppins",serif;
        font-weight: bold;
        font-size: 18px;
        line-height: 27px;
        text-align: center;
        color: $darkGrey;
    }

    .pin-label {
        color: $mediumGrey;
        font-weight: normal;
        margin-bottom: 25px;
    }
</style>